import { Slide } from "react-reveal";
import WebsiteSolution from "./list/WebsiteSolution";
import SystemSolution from "./list/SystemSolution";
import AppSolution from "./list/AppSolution";
import EcommerceSolution from "./list/EcommerceSolution";
import DigitalMarketingSolution from "./list/DigitalMarketingSolution";
import BrandingSolution from "./list/BrandingSolution";
import SMmanagementSolution from "./list/SMmanagementSolution";
import ICTConsultancySolution from "./list/ICTConsultancySolution";
import ICTTrainingSolution from "./list/ICTTrainingSolution";
import ICTSupplySolution from "./list/ICTSupplySolution";
import CCTVSolution from "./list/CCTVSolution";
import NetworkingSolution from "./list/NetworkingSolution";

const SolutionsBody = () => {
  return (
    <section className="page solutions box-shadow">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="page-head section-spacing-20 width-800 margin-auto">
              <p className="page-content-subtitle font-inter-regular">
                We provide a comprehensive range of ICT solutions designed to
                power businesses and organizations at every stage of growth.
              </p>
            </div>
            <div className="section-body section-spacing-100 no-padding-top">
              <div className="separated-page-section section-spacing-50">
                <Slide top>
                  <h2 className="ntuna-text-fill">
                    Comprehensive ICT solutions
                  </h2>
                </Slide>

                <div className="separated-paragraphs-container flex">
                  <p>
                    When we say comprehensive, we mean comprehensive. Our
                    experience and technical expertise enable us to deliver
                    fully integrated, end-to-end ICT solutions across all areas
                    of your organization.
                  </p>
                  <p>
                    Many providers focus on limited areas of IT but
                    organizations need a complete, integrated approach. At
                    NTUNA.COM, we deliver end-to-end ICT solutions so you can
                    focus on your business with confidence.
                  </p>
                </div>
              </div>
              <div>
                <ul className="solutions-items-container">
                  <WebsiteSolution />
                  <SystemSolution />
                  <AppSolution />
                  <EcommerceSolution />
                  <DigitalMarketingSolution />
                  <BrandingSolution/>
                  <SMmanagementSolution/>
                  <ICTConsultancySolution/>
                  <ICTTrainingSolution/>
                  <ICTSupplySolution/>
                  <CCTVSolution/>
                  <NetworkingSolution/>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionsBody;
